    // Back to top: listen to scroll instead of assigning window.onscroll, so other scripts' scroll handlers survive.
    function toggleBackToTopButton() {
      const backToTopButton = document.getElementById("back-to-top");
      if (!backToTopButton) return;
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        backToTopButton.style.display = "block";
      } else {
        backToTopButton.style.display = "none";
      }
    }

    window.addEventListener("scroll", toggleBackToTopButton, { passive: true });

    const backToTopLink = document.getElementById("back-to-top");
    if (backToTopLink) {
      backToTopLink.addEventListener("click", function (event) {
        event.preventDefault();
        scrollToTop();
        // Keyboard activation (no pointer click): move focus to the first skip link at the top of the page,
        // the #skptop region this link points to, so the next Tab starts from the top.
        if (event.detail === 0) {
          const skipLink = document.querySelector("#skptop .skip-to-content-link");
          if (skipLink) skipLink.focus({ preventScroll: true });
        }
      });
    }
    
    function scrollToTop() {
      const startPosition = window.scrollY;
      const duration = 500; // Duration in milliseconds
      let startTime = null;
    
      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Ensure progress does not exceed 1
    
        // Easing function (easeOutCubic)
        const ease = 1 - Math.pow(1 - progress, 3);
        window.scrollTo(0, startPosition * (1 - ease));
    
        if (timeElapsed < duration) {
          requestAnimationFrame(animation);
        }
      }
    
      requestAnimationFrame(animation);
    }

    // External Links Warning
document.addEventListener('DOMContentLoaded', () => {
  const handleExternalLinks = () => {
    const links = document.querySelectorAll('a');
    const excludedLinks = []; // You can populate this array with links you want to exclude from the external link handling

    const isThirdParty = (url) => {
      try {
        const linkHost = new URL(url).hostname;
        const currentHost = window.location.hostname;
        return linkHost && linkHost !== currentHost;
      } catch (e) {
        return false;
      }
    };

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;

      // Open in new tab
      link.setAttribute('target', '_blank');

      // Set aria-label
      const existingText = link.textContent.trim();
      const ariaLabel = `${existingText}, This link will open in a new tab`;
      link.setAttribute('aria-label', ariaLabel);

      // Update image alt text
      const img = link.querySelector('img, svg');
      if (img) {
        let altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  // Adding timeout to ensure the DOM is fully loaded
  setTimeout(() => {
    handleExternalLinks();
  }, 500); // Adjust the timeout duration as needed (500ms here)
});

 
// Email and phone number labels
document.addEventListener('DOMContentLoaded', () => {
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');
 
    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();
 
      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };
 
  handleContactLinks();
});

// Select all <br> elements on the page
const brElements = document.querySelectorAll('br');

// Loop through each <br> element and add aria-hidden="true"
brElements.forEach(br => {
  br.setAttribute('aria-hidden', 'true');
});

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".oc__product_tablinks");

  // Sync aria-expanded with oc-active class
  function syncAriaExpanded() {
    tabs.forEach(tab => {
      tab.setAttribute(
        "aria-expanded",
        tab.classList.contains("oc-active") ? "true" : "false"
      );
    });
  }

  // Run once on load
  syncAriaExpanded();

  // Watch for class changes
  const observer = new MutationObserver(syncAriaExpanded);

  tabs.forEach(tab => {
    observer.observe(tab, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });
});

$(document).ready(function () {
 
  // Function to fix radio buttons accessibility
  function fixRadioAccessibility($target) {
    $target.find('input.oc__subscription-tabinner-rinput').each(function () {
      const $input = $(this);
      const $labelText = $input.closest('label')
                               .find('.oc__subscription-tabinner-radio-lbl span')
                               .first();
 
      if ($labelText.length) {
       
        $input.attr('aria-label', $labelText.text().trim());
 
 
        $labelText.attr('aria-hidden', 'true');
        $labelText.find('*').attr('aria-hidden', 'true'); // inner spans bhi
      }
    });
  }
 
 
  fixRadioAccessibility($('.oc__subscription-tabinner-box'));
 
 
  const observer = new MutationObserver(function () {
    fixRadioAccessibility($('.oc__subscription-tabinner-box'));
  });
 
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
 
});

$('a.full-unstyled-link').each(function () {
    if ($.trim($(this).html()) === '') {
        $(this).attr({
            'role': 'presentation',
            'tabindex': '-1',
            'aria-hidden': 'true'
        });
    }
});
